import api from './api';

const contactsService = {
  // Récupérer tous les contacts
  getAllContacts: async (params = {}) => {
    try {
      const response = await api.get('/contacts', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching contacts:', error);
      throw error;
    }
  },

  // Récupérer un contact par ID
  getContactById: async (id) => {
    try {
      const response = await api.get(`/contacts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contact:', error);
      throw error;
    }
  },

  // Créer un nouveau contact
  createContact: async (contactData) => {
    try {
      const response = await api.post('/contacts', contactData);
      return response.data;
    } catch (error) {
      console.error('Error creating contact:', error);
      throw error;
    }
  },

  // Mettre à jour un contact
  updateContact: async (id, contactData) => {
    try {
      const response = await api.put(`/contacts/${id}`, contactData);
      return response.data;
    } catch (error) {
      console.error('Error updating contact:', error);
      throw error;
    }
  },

  // Archiver un contact
  archiveContact: async (id) => {
    try {
      const response = await api.patch(`/contacts/${id}/archive`);
      return response.data;
    } catch (error) {
      console.error('Error archiving contact:', error);
      throw error;
    }
  },

  // Restaurer un contact archivé
  restoreContact: async (id) => {
    try {
      const response = await api.patch(`/contacts/${id}/restore`);
      return response.data;
    } catch (error) {
      console.error('Error restoring contact:', error);
      throw error;
    }
  },

  // Supprimer un contact
  deleteContact: async (id) => {
    try {
      const response = await api.delete(`/contacts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting contact:', error);
      throw error;
    }
  },

  // Recherche de contacts
  searchContacts: async (searchParams) => {
    try {
      const response = await api.post('/contacts/search', searchParams);
      return response.data;
    } catch (error) {
      console.error('Error searching contacts:', error);
      throw error;
    }
  },

  // Récupérer les types de contacts
  getContactTypes: async () => {
    try {
      const response = await api.get('/config/contact-types');
      return response.data;
    } catch (error) {
      console.error('Error fetching contact types:', error);
      throw error;
    }
  },

  // Récupérer les groupes de contacts
  getContactGroups: async () => {
    try {
      const response = await api.get('/config/contact-groups');
      return response.data;
    } catch (error) {
      console.error('Error fetching contact groups:', error);
      throw error;
    }
  },

  // Récupérer les demandes de contact
  // AJ1 — `params` permet de borner l'appel du tableau de bord (limit=20). Sans paramètre,
  // le comportement reste celui d'avant pour les autres écrans.
  getContactRequests: async (params = {}) => {
    try {
      const response = await api.get('/contacts-agence', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching contact requests:', error);
      throw error;
    }
  },

  // Compteurs (AJ1) : un nombre, sans rapatrier les documents
  getContactsCount: async (status = 'active') => {
    const response = await api.get('/contacts/count', { params: { status } });
    return response.data?.count ?? 0;
  },

  getContactRequestsCount: async () => {
    const response = await api.get('/contacts-agence/count');
    return response.data?.count ?? 0;
  },

  // Marquer une demande comme traitée
  markRequestAsProcessed: async (id) => {
    try {
      const response = await api.patch(`/contact-requests/${id}/process`);
      return response.data;
    } catch (error) {
      console.error('Error marking request as processed:', error);
      throw error;
    }
  },
};

export default contactsService;
